import { Filter } from "@components/Filters/Filter"
import FilterContainer from "@components/Filters/FilterContainer"
import { useIntl } from "@components/Intl"
import { Box } from "@components/Layout"
import React from "react"
import { articleCombinationFilters } from "./filterOptions"

interface Props {
  style: string
  uid: string
  onSelectStyle: (key: string) => void
}

const Filters: React.FC<Props> = ({ style, uid, onSelectStyle }) => {
  const { messages } = useIntl()
  return (
    <FilterContainer
      display="flex"
      justifyContent={["flex-start", "space-between"]}
      mb={4}
      pb={[4, 2]}
      mt={2}
    >
      <Box display="flex">
        {articleCombinationFilters[uid].map((key) => (
          <Filter
            status={style === key ? "active" : "idle"}
            key={key}
            onClick={() => onSelectStyle(key)}
            icon={key as string}
          >
            {messages.properties.style.options[key]}
          </Filter>
        ))}
      </Box>
    </FilterContainer>
  )
}

export default Filters
